import { Link } from "react-router-dom";

function Blog() {
  return (
    <div className="container">
      <div className="col float-end ">
        <Link to="/">
          <button type="button" className="btn-close p-3" aria-label="Close" />
        </Link>
      </div>
      <div className="container">
        <div className="col my-5 text-center">
          <div className="col py-1">
            <p className="fs-1">Guest Area</p>
          </div>
          <div className="col py-1">
            <p>Please enter the password below.</p>
          </div>
          <div className="col">
            <div class="mb-3 ">
              <div class="col d-grid gap-2 col-4 mx-auto">
                <input
                  type="password"
                  className="form-control py-2"
                  id="inputPassword"
                  placeholder="Password"
                />
              </div>
            </div>
            <div className="col">
              <div class="d-grid gap-2 col-4 mx-auto">
                <button
                  className="btn btn-dark py-2"
                  type="button"
                  placeholder="Password"
                >
                  Go
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
